import axios from './AxiosConfig';

export function getHistory() {
    return axios.get('/api/reports/history', {_hideErrors: true});
}